import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ae370a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer_input" }
const _hoisted_2 = { class: "input-fields" }
const _hoisted_3 = { class: "input-fields-wrapper" }
const _hoisted_4 = { class: "input-fields-wrapper" }

import { reactive } from "vue";
import CustomInputField from "../generics/CustomInputField.vue";
import { useBookingStore, order } from "@/store/bookingStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerInputSwishBlock',
  setup(__props) {

const state = reactive({
  firstName: "",
  lastName: "",
  country: "",
  birthday: "",
});

console.log(state);

const bookingStore = useBookingStore();

function handle_paye_input(event: any, key_name: keyof order) {
  bookingStore.order[key_name as keyof order] = event;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CustomInputField, {
          id: "nameSwish",
          class: "input-field",
          label: "Förnamn",
          initValue: _unref(bookingStore).order.swishFirstname,
          onOnInput: _cache[0] || (_cache[0] = ($event: any) => (handle_paye_input($event, 'swishFirstname')))
        }, null, 8, ["initValue"]),
        _createVNode(CustomInputField, {
          id: "surnameSwish",
          class: "input-field",
          label: "Efternamn",
          initValue: _unref(bookingStore).order.swishSurname,
          onOnInput: _cache[1] || (_cache[1] = ($event: any) => (handle_paye_input($event, 'swishSurname')))
        }, null, 8, ["initValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(CustomInputField, {
          id: "phonenumberSwish",
          class: "input-field",
          label: "Telefonnummer",
          initValue: _unref(bookingStore).order.swishPhoneNumber,
          onOnInput: _cache[2] || (_cache[2] = ($event: any) => (handle_paye_input($event, 'swishPhoneNumber')))
        }, null, 8, ["initValue"])
      ])
    ])
  ]))
}
}

})